// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3NmrO","desc":"styles_desc__zDTlb","table":"styles_table__X+iGL","tableContent":"styles_tableContent__09e+S","itemVariety":"styles_itemVariety__djioZ"};